<template>
  <div class="materials-overspend">
    <div v-if="!params" class="filters">
      <div class="filters__item">
        <CustomSelect
          :options="residents"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="filters.resident_id"
          @change="onResidentChange"
        />
      </div>
      <div class="filters__item" style="width: 250px;">
        <CustomSelect
          :options="projectTypes"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="filters.project_type_id"
          @change="onProjectTypeChange"
        />
      </div>
    </div>

    <CustomTable
      title="Перезаказ материалов"
      :rowsData="rowsData"
      :columns="columns"
      :loading="isLoading"
      :small="true"
      :show-search="true"
      :custom-header="true"
      :custom-body="true"
      :sticky-header="false"
      :update-data="this.loadMaterials"
      :bottom-row="true"
    >
      <template #customHeader="props">
        <q-tr :props="props">
          <q-th rowspan="2" class="text-left" style="font-weight: 700;"
            >Материал</q-th
          >
          <q-th rowspan="2" class="text-left" style="font-weight: 700;"
            >ID проекта</q-th
          >
          <q-th rowspan="2" class="text-left" style="font-weight: 700;"
            >Ед. изм.</q-th
          >
          <q-th colspan="3" class="text-center" style="font-weight: 700;"
            >Количество</q-th
          >
          <q-th colspan="3" class="text-center" style="font-weight: 700;"
            >Сумма</q-th
          >
        </q-tr>
        <q-tr :props="props">
          <q-th
            class="text-right tw-border-l-2"
            style="border-left: 1px solid rgba(0, 0, 0, 0.12);"
            >В смете</q-th
          >
          <q-th class="text-right">Заказано</q-th>
          <q-th class="text-right">Перерасход</q-th>
          <q-th class="text-right">В смете</q-th>
          <q-th class="text-right">Заказано</q-th>
          <q-th class="text-right">Перерасход</q-th>
        </q-tr>
      </template>

      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.material_name || '-' }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.project_id || '-' }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.material_unit_name || '-' }}
          </custom-table-cell>
          <custom-table-cell
            :align="props.row.smeta_cnt ? 'right' : 'center'"
            vertical-align="center"
          >
            <span
              class="smeta-cnt"
              :class="{ 'smeta-cnt--not-in-smeta': !props.row.smeta_cnt && props.row.is_not_in_smeta }"
            >
              {{ props.row.smeta_cnt ? numberWithCommas(props.row.smeta_cnt, null, 2) : props.row.is_not_in_smeta ? 'Нет в смете' : '-' }}
            </span>
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            {{ numberWithCommas(props.row.ordered_cnt, null, 2) || '-' }}
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            <span class="tw-text-red-600 tw-font-semibold">
              {{ numberWithCommas(props.row.overspend_cnt, null, 2) || '-' }}
              {{ props.row.material_unit_name || '-' }}
            </span>
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            <Amount :value="props.row.smeta_sum" :round="2" />
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            <Amount :value="props.row.ordered_sum" :round="2" />
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            <span class="tw-text-red-600 tw-font-semibold">
              <Amount :value="props.row.overspend_sum" :round="2" />
            </span>
          </custom-table-cell>
        </q-tr>
      </template>
      <template v-if="!!rowsData?.length" #bottomRow="props">
        <q-tr class="bg-grey-3 text-bold">
          <q-td colspan="8">Итого</q-td>
          <q-td align="right"> <Amount :value="getOverspendAmount()" /></q-td>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import { numberWithCommas } from "@/services";
import {
  getSmetaMaterialsOverspend,
  materialsOverspendColumns,
} from "./services";
import { getProjectTypes, getResidentList } from "../ResidentialSettings/services";
import Amount from "@/components/common/Amount.vue";

export default {
  name: "MaterialsOverspend",
  components: { CustomTable, CustomTableCell, CustomSelect, Amount },
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      residents: [],
      projectTypes: [],
      rowsData: [],
      isLoading: false,
      isHydratingFromUrl: false,
      isUrlSyncScheduled: false,
      columns: materialsOverspendColumns,
      filters: {
        resident_id: null,
        sbs_project_id: null,
        project_type_id: null,
      },
    };
  },
  computed: {
    effectiveFilters() {
      if (this.params) {
        return {
          sbs_project_id: this.params.sbs_project_id,
          project_type_id: this.params.project_type_id,
        }
      }
      return this.filters
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.params) return;
        if (this.isHydratingFromUrl) return;
        this.queueSyncFiltersToUrl();
      },
    },
    params: {
      deep: true,
      immediate: false,
      handler(newParams) {
        if (newParams?.sbs_project_id && newParams?.project_type_id) {
          this.loadMaterials()
        }
      },
    },
  },
  methods: {
    numberWithCommas,
    getQueryNumber(key) {
      const raw = this.$route?.query?.[key];
      const value = Array.isArray(raw) ? raw[0] : raw;
      if (value === undefined || value === null || value === "") return null;
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    buildQueryFromFilters() {
      const nextQuery = { ...(this.$route?.query || {}) };

      if (this.filters.resident_id) nextQuery.resident_id = String(this.filters.resident_id);
      else delete nextQuery.resident_id;

      if (this.filters.sbs_project_id) nextQuery.sbs_project_id = String(this.filters.sbs_project_id);
      else delete nextQuery.sbs_project_id;

      if (this.filters.project_type_id) nextQuery.project_type_id = String(this.filters.project_type_id);
      else delete nextQuery.project_type_id;

      return nextQuery;
    },
    isSameQuery(a, b) {
      const aKeys = Object.keys(a || {}).sort();
      const bKeys = Object.keys(b || {}).sort();
      if (aKeys.length !== bKeys.length) return false;
      for (let i = 0; i < aKeys.length; i += 1) {
        if (aKeys[i] !== bKeys[i]) return false;
        const key = aKeys[i];
        const aVal = a?.[key];
        const bVal = b?.[key];
        const aStr = Array.isArray(aVal) ? String(aVal[0] ?? "") : String(aVal ?? "");
        const bStr = Array.isArray(bVal) ? String(bVal[0] ?? "") : String(bVal ?? "");
        if (aStr !== bStr) return false;
      }
      return true;
    },
    queueSyncFiltersToUrl() {
      if (this.isUrlSyncScheduled) return;
      this.isUrlSyncScheduled = true;
      Promise.resolve().then(() => {
        this.isUrlSyncScheduled = false;
        this.syncFiltersToUrl();
      });
    },
    syncFiltersToUrl() {
      const nextQuery = this.buildQueryFromFilters();
      const currentQuery = this.$route?.query || {};
      if (this.isSameQuery(nextQuery, currentQuery)) return;
      this.$router?.replace({ query: nextQuery });
    },
    async loadResidents() {
      const res = await getResidentList();
      this.residents = res || [];
    },
    async loadProjectTypes(resident_id) {
      const res = await getProjectTypes(resident_id);
      this.projectTypes = res || [];
    },
    async loadMaterials() {
      const { sbs_project_id, project_type_id } = this.effectiveFilters
      if (!sbs_project_id || !project_type_id) return;
      this.isLoading = true;
      const res = await getSmetaMaterialsOverspend({
        sbs_project_id,
        project_type_id,
      });
      this.isLoading = false;
      this.rowsData = res || [];
    },
    async hydrateFromUrl() {
      this.isHydratingFromUrl = true;

      const residentIdFromUrl = this.getQueryNumber("resident_id");
      const projectTypeIdFromUrl = this.getQueryNumber("project_type_id");
      const sbsProjectIdFromUrl = this.getQueryNumber("sbs_project_id");

      await this.loadResidents();

      this.filters.resident_id = null;
      this.filters.sbs_project_id = null;
      this.filters.project_type_id = null;
      this.projectTypes = [];
      this.rowsData = [];

      if (!residentIdFromUrl) {
        this.isHydratingFromUrl = false;
        this.syncFiltersToUrl();
        return;
      }

      this.filters.resident_id = residentIdFromUrl;
      const residentRow = (this.residents || []).find(
        (r) => Number(r?.resident_id) === Number(residentIdFromUrl)
      );
      this.filters.sbs_project_id =
        sbsProjectIdFromUrl || residentRow?.sbs_project_id || null;

      await this.loadProjectTypes(residentIdFromUrl);

      if (projectTypeIdFromUrl) {
        const exists = (this.projectTypes || []).some(
          (pt) =>
            Number(pt?.project_type_id) === Number(projectTypeIdFromUrl)
        );
        this.filters.project_type_id = exists ? projectTypeIdFromUrl : null;
      }

      if (this.filters.project_type_id) {
        await this.loadMaterials();
      }

      this.isHydratingFromUrl = false;
      this.syncFiltersToUrl();
    },
    onResidentChange(value, row) {
      this.filters.resident_id = value;
      this.filters.sbs_project_id = row?.sbs_project_id || null;
      this.filters.project_type_id = null;
      this.projectTypes = [];
      this.rowsData = [];
      if (value) {
        this.loadProjectTypes(value);
      }
    },
    onProjectTypeChange(value) {
      this.filters.project_type_id = value;
      this.rowsData = [];
      if (value) {
        this.loadMaterials();
      }
    },
    getOverspendAmount() {
      return this.rowsData.reduce((acc, item) => {
        return acc + (item.overspend_sum || 0);
      }, 0);
    },
  },
  mounted() {
    if (this.params) {
      this.loadMaterials()
    } else {
      this.hydrateFromUrl()
    }
  },
};
</script>

<style scoped lang="scss">
.materials-overspend {
  padding: 10px 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  margin-bottom: 16px;

  &__item {
    min-width: 150px;
    width: 240px;
  }
}

.smeta-cnt {
  display: inline-block;

  &--not-in-smeta {
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(245, 124, 0, 0.14);
    color: #c2410c;
    font-weight: 500;
  }
}
</style>
